import { Routes } from '@angular/router';

import { AuthGuard } from '@plugins/client/auth';
import { MultilanguageGuard } from '@plugins/client/multilanguage/multilanguage.guard';
import { AppGuard } from '@plugins/client/routing/app.guard';
import { queueGuards } from '@plugins/client/routing/queue.guard';
import { createTranslationGuard } from '@plugins/client/translate/guards';

import { InstanceGuard } from './guards';

const backofficeImport = () =>
  import('./backoffice/backoffice.component').then(
    (im) => im.BackofficeComponent,
  );
const frontofficeImport = () =>
  import('./frontend/frontend.component').then((im) => im.FrontendComponent);

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'admin',
        canActivate: [
          queueGuards([AuthGuard, InstanceGuard, MultilanguageGuard]),
          AppGuard,
        ],
        canActivateChild: [createTranslationGuard(backofficeImport)],
        data: { role: 'editor' },
        loadChildren: () => import('./backoffice/backoffice.routes'),
      },
      {
        path: '',
        canActivate: [
          queueGuards([AuthGuard, InstanceGuard, MultilanguageGuard]),
          AppGuard,
        ],
        canActivateChild: [createTranslationGuard(frontofficeImport)],
        loadChildren: () => import('./frontend/frontend.routes'),
      },
      {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
      },
    ],
  },
];
